<template>
  <el-dialog :title="title" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height">

          <div class="table_main" style="height: 400px!important;">
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  发票类型
                </th>
                <td >
                  <el-select v-model="formData.invoiceType" placeholder="请选择发票类型" @change="changeInvoiceType" clearable>
                    <el-option :value="1" label="安装"></el-option>
                    <el-option :value="2" label="维修"></el-option>
                    <el-option :value="9" label="其他"></el-option>
                  </el-select>
                </td>
                <th>
                  发票验证
                </th>
                <td>
                  <span v-if="formData.correctCheck == 1">已同步费控</span>
                  <span v-if="formData.correctCheck == 8">验真</span>
                  <span v-if="formData.correctCheck == 9">验假</span>
                  <span v-else="formData.correctCheck == 0">待验证</span>
                </td>
                <th>
                  验假备注
                </th>
                <td colspan="3">
                  <el-input type="text" autocomplete="off" v-model="formData.correctCheckRemark" :disabled="true" clearable/>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  发票号
                </th>
                <td colspan="3">
                  <el-input type="text" autocomplete="off" v-model="formData.invoiceNo"  clearable/>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  发票金额
                </th>
                <td >
                  <el-input type="text" autocomplete="off" v-model="formData.invoiceNoAmount" @change="changeInvoiceNoAmount"  clearable/>
                </td>
                <th>
                  税率
                </th>
                <td >
                  <el-input type="text" autocomplete="off" v-model="formData.taxRate"  disabled clearable/>
                </td>
                <th>
                  税金
                </th>
                <td >
                  <el-input type="text" autocomplete="off" v-model="formData.taxAmount" disabled clearable/>
                </td>
              </tr>
              <tr>
                <th>
                  发票备注
                </th>
                <td colspan="7">
                  <el-input class="annotate" type="textarea" :rows="2"  size="small"
                            v-model="formData.invoiceRemark" ></el-input>
                </td>
              </tr>
              <tr>
                <th>发票文件</th>
                <td colspan="">
                  <div >
                    <photo-upload :photo-url.sync="formData.invoicePic" :uploadType="uploadType" />
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import PhotoUpload from "./pdfUpload.vue";
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'title','rowData','taxData','invoiceIndex'],
  mixins: [selectDialogMixins],
  components: {PhotoUpload, pager },

  created() {
    // this.initSetting();
    if (this.taxData){
      this.siteInvoiceRate = this.taxData.siteInvoiceRate;
      this.siteWxInvoiceRate = this.taxData.siteWxInvoiceRate;
      this.siteOtherInvoiceRate = this.taxData.siteOtherInvoiceRate;
    }
    if (this.rowData){
      this.$objCopy(this.rowData, this.formData)
    }
    if (this.param) {
      if (this.param.siteId) {
        this.formData.siteId = this.param.siteId
      }
    }
    if (this.invoiceIndex!=null){
      this.returnData.index = this.invoiceIndex;
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      showPreview: false,
      uploadType:'.pdf',
      returnData:{
        index:null,
        data:{}
      },
      siteInvoiceRate:0,
      siteWxInvoiceRate:0,
      siteOtherInvoiceRate:0,
      //以上树形
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      formData: {
        invoiceType:null,
        correctCheck:0,
        correctCheckRemark:null,
        invoiceNo:null,
        invoiceNoAmount:null,
        taxRate:null,
        taxAmount:null,
        invoiceRemark:null,
        invoicePic:null,
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      searchSiteAccount: null,
      selectedRow: {
        id: '', name: '', orgId: null, orgIdPath: null
      }
    };
  },


  methods: {
    changeInvoiceNoAmount(){
      if (this.formData.invoiceType){
        this.formData.taxAmount = this.formData.invoiceNoAmount*this.formData.taxRate
      }
    },
    changeInvoiceType(){
      if (this.formData.invoiceType == 1){
        this.formData.taxRate = this.siteInvoiceRate
      }else if (this.formData.invoiceType == 2){
        this.formData.taxRate = this.siteWxInvoiceRate
      }else if (this.formData.invoiceType == 9){
        this.formData.taxRate = this.siteOtherInvoiceRate
      }
      if (this.formData.invoiceNoAmount){
        this.changeInvoiceNoAmount()
      }
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent (e) {
      console.log(e.row.id,'单元格点击事件')
    },




    commitRow() {
        if(!this.formData.invoiceType){
          this.$message.error('请选择发票类型')
          return
        }
        if(!this.formData.invoiceNo){
          this.$message.error('请输入发票号')
          return
        }
        if(!this.formData.invoiceNoAmount){
          this.$message.error('请输入发票金额')
          return
        }
        this.returnData.data = this.formData
        this.$emit('commit', this.returnData)
        this.dialogClose()
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },


    // 搜索
    searchEvent() {
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
      this.reloadTree()
    },





    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.sfSettleApply.getBatchSettlesUrl,
        param: this.formData,
        method: 'post',
        columns: [
          { type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
          { title: '结算单号', field: 'settleNo', width: 140, },
          { title: '状态', field: 'stat', width: 130, slots: {
              default: ({row}) => {
                if (row.stat == 1) {
                  return [
                    <div class="txt-status ">
                      <span>结算生成</span>
                    </div>
                  ];
                } else if (row.stat == 2) {
                  return [
                    <div class="txt-status neutral">
                      <span>待确认</span>
                    </div>
                  ];
                } else if (row.stat == 3) {
                  return [
                    <div class="txt-status ">
                      <span>已确认</span>
                    </div>
                  ];
                } else if (row.stat == 4) {
                  return [
                    <div class="txt-status neutral">
                      <span>异议</span>
                    </div>
                  ];
                } else if (row.stat == 11) {
                  return [
                    <div class="txt-status neutral">
                      <span>待开票</span>
                    </div>
                  ];
                } else if (row.stat == 13) {
                  return [
                    <div class="txt-status ">
                      <span>已开票</span>
                    </div>
                  ];
                } else if (row.stat == 15) {
                  return [
                    <div class="txt-status ">
                      <span>已收票</span>
                    </div>
                  ];
                } else if (row.stat == 29) {
                  return [
                    <div class="txt-status ">
                      <span>已结算</span>
                    </div>
                  ];
                } else if (row.stat == 99) {
                  return [
                    <div class="txt-status disable">
                      <span>取消</span>
                    </div>
                  ];
                }
              }
            }
          },
          { title: '服务中心',field: 'orgName', width: 100,},
          { title: '服务商', field: 'siteName', width: 100, },
          { title: '总金额', field: 'amount', width: 80, slots: {default: 'amountShow'}},
          { title: '创建人', field: 'createBy', width: 80, },
          { title: '创建时间', field: 'createTime', width: 150, },
        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: 100%;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}




::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}



::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
